import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCevoComponent } from './simple-icons-cevo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCevoComponent ],
    exports:      [ SimpleIconsCevoComponent ],
    bootstrap:    []
})
export class SimpleIconsCevoModule {}
